﻿document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('shirt-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  
  const baseImage = document.getElementById('configurator-base-image');
  const fileInput = document.getElementById('config-upload');
  const uploadBtn = document.getElementById('config-upload-btn');
  const textInput = document.getElementById('config-text-input');
  const addTextBtn = document.getElementById('config-add-text-btn');
  const zoomInBtn = document.getElementById('config-zoom-in');
  const zoomOutBtn = document.getElementById('config-zoom-out');
  const rotateLeftBtn = document.getElementById('config-rotate-left');
  const rotateRightBtn = document.getElementById('config-rotate-right');
  const removeBtn = document.getElementById('config-remove');
  const frontInput = document.getElementById('custom-design-front');
  const backInput = document.getElementById('custom-design-back');
  const printFrontInput = document.getElementById('custom-print-front');
  const printBackInput = document.getElementById('custom-print-back');
  const previewFrontInput = document.getElementById('custom-preview-front');
  const previewBackInput = document.getElementById('custom-preview-back');
  const originalFrontInput = document.getElementById('custom-original-front');
  const originalBackInput = document.getElementById('custom-original-back');
  const fullscreenBtn = document.getElementById('config-fullscreen-btn');
  const frontBtn = document.getElementById('config-side-front');
  const backBtn = document.getElementById('config-side-back');
  const configuratorContainer = document.getElementById('configurator-container');
  const frontImageUrl = configuratorContainer ? configuratorContainer.getAttribute('data-front-image') : null;
  const backImageUrl = configuratorContainer ? configuratorContainer.getAttribute('data-back-image') : null;
  const previewImages = {
    front: new Image(),
    back: new Image()
  };
  previewImages.front.crossOrigin = 'anonymous';
  previewImages.back.crossOrigin = 'anonymous';
  previewImages.front.src = frontImageUrl || (baseImage ? baseImage.src : '');
  previewImages.back.src = backImageUrl || frontImageUrl || (baseImage ? baseImage.src : '');
  const wrapper = document.querySelector('.product-configurator-wrapper');
  const elementControls = document.querySelector('.element-controls');
  const doneBtn = document.getElementById('config-done-btn');
  const lockContainer = document.querySelector('.element-lock-toggle');
  const editToggleBtn = document.getElementById('lock-toggle-edit');
  const lockToggleBtn = document.getElementById('lock-toggle-lock');
  const customModalOverlay = document.getElementById('config-custom-modal');
  const customModalText = document.getElementById('config-modal-text');
  const customModalClose = document.getElementById('config-modal-close');
  
  if (customModalClose) {
    customModalClose.addEventListener('click', () => {
      customModalOverlay.style.display = 'none';
    });
  }

  function showConfigModal(text) {
    if (customModalOverlay && customModalText) {
      customModalText.textContent = text;
      customModalOverlay.style.display = 'flex';
    } else {
      alert(text); // Fallback
    }
  }
  
  // Detect if it is a sticker
  const isSticker = configuratorContainer ? configuratorContainer.getAttribute('data-is-sticker') === 'true' : false;
  
  // Printable Area Bounding Box (Centered on 600x600 canvas, full area with safe margin)
  const printBox = { x: 20, y: 20, w: 560, h: 560 };

  // Data Structure
  let currentSide = 'front';
  const designs = { front: [], back: [] };
  let elements = designs.front;
  
  // Base Price loading
  const basePriceAttr = configuratorContainer ? configuratorContainer.getAttribute('data-base-price') : null;
  let basePrice = basePriceAttr ? parseFloat(basePriceAttr) : 17.00;

  let selectedElementIndex = -1;
  let isDragging = false;
  let startX, startY;

  // 3D Engine Variables
  let is3DMode = false;
  let scene, camera, renderer, controls, modelGroup, decalGroup, shirtMesh = null, modelReady = false, animationFrameId = null;
  let modelScale = 1;
  const shirtModelUrl = configuratorContainer ? configuratorContainer.getAttribute('data-shirt-model') : null;
  const toggle3DBtn = document.getElementById('config-toggle-3d');
  const threeContainer = document.getElementById('three-container');
  const threeDecalTextures = [];

  const decalConfig = {
    width: 2.6,
    height: 2.8,
    yOffset: 0.0,
    frontZ: 0.14,
    backZ: -0.14
  };

  function disposeDecals() {
    if (!decalGroup) return;
    while (decalGroup.children.length) {
      const child = decalGroup.children.pop();
      if (child.geometry) child.geometry.dispose();
      if (child.material) {
        if (child.material.map) child.material.map.dispose();
        child.material.dispose();
      }
    }
    threeDecalTextures.length = 0;
  }

  function createElementTexture(el) {
    const size = 512;
    const textureCanvas = document.createElement('canvas');
    textureCanvas.width = size;
    textureCanvas.height = size;
    const tctx = textureCanvas.getContext('2d');
    tctx.clearRect(0, 0, size, size);

    if (el.type === 'image' && el.img) {
      tctx.drawImage(el.img, 0, 0, size, size);
    } else if (el.type === 'text') {
      tctx.fillStyle = el.color || '#000000';
      tctx.font = `bold ${Math.round(size * 0.24)}px "Arial Black", Impact, sans-serif`;
      tctx.textAlign = 'center';
      tctx.textBaseline = 'middle';
      tctx.fillText(el.text, size / 2, size / 2, size * 0.92);
    }

    const texture = new THREE.CanvasTexture(textureCanvas);
    texture.encoding = THREE.sRGBEncoding;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.anisotropy = renderer ? Math.min(8, renderer.capabilities.getMaxAnisotropy()) : 1;
    texture.needsUpdate = true;
    threeDecalTextures.push(texture);
    return texture;
  }

  function addElementDecal(el, side) {
    if (!decalGroup || !modelReady) return;

    // Dynamically find shirtMesh from modelGroup if it's not set
    if (!shirtMesh && modelGroup) {
      modelGroup.traverse((child) => {
        if (child.isMesh) {
          shirtMesh = child;
        }
      });
    }

    const centerX = el.x + el.w / 2;
    const centerY = el.y + el.h / 2;
    const xNorm = (centerX - (printBox.x + printBox.w / 2)) / printBox.w;
    const yNorm = (centerY - (printBox.y + printBox.h / 2)) / printBox.h;
    const width3D = Math.max(0.08, (el.w / printBox.w) * decalConfig.width);
    const height3D = Math.max(0.08, (el.h / printBox.h) * decalConfig.height);

    const x3D = (side === 'back' ? -xNorm : xNorm) * decalConfig.width;
    const y3D = decalConfig.yOffset - yNorm * decalConfig.height;
    
    const normal = new THREE.Vector3(0, 0, side === 'back' ? -1 : 1);
    let position = new THREE.Vector3(x3D, y3D, side === 'back' ? decalConfig.backZ : decalConfig.frontZ);
    
    let geometry = null;
    let useDecal = false;

    if (typeof THREE.DecalGeometry !== 'undefined' && shirtMesh) {
      try {
        // GLB models are centered and scaled after loading. Force their world
        // matrices to update before raycasting so decals land on the visible
        // outer shell rather than using stale, unscaled coordinates.
        modelGroup.updateMatrixWorld(true);
        shirtMesh.updateMatrixWorld(true);

        const modelBounds = new THREE.Box3().setFromObject(modelGroup);
        const fallbackZ = side === 'back' ? modelBounds.min.z - 0.01 : modelBounds.max.z + 0.01;
        position = new THREE.Vector3(x3D, y3D, fallbackZ);

        // Cast a local ray to find the exact surface intersection point and normal
        const rayOriginZ = side === 'back' ? modelBounds.min.z - 1.0 : modelBounds.max.z + 1.0;
        const rayOrigin = new THREE.Vector3(x3D, y3D, rayOriginZ);
        const rayDir = new THREE.Vector3(0, 0, side === 'back' ? 1.0 : -1.0);
        const localRaycaster = new THREE.Raycaster(rayOrigin, rayDir);
        const intersects = localRaycaster.intersectObject(shirtMesh, true);
        
        let finalPos = position;
        let finalNormal = normal;
        
        if (intersects.length > 0) {
          finalPos = intersects[0].point;
          if (intersects[0].face) {
            finalNormal = intersects[0].face.normal.clone();
            finalNormal.transformDirection(shirtMesh.matrixWorld);
          }

          // Keep the artwork a fraction above the garment surface. This avoids
          // z-fighting and prevents the projection volume from reaching the
          // inside layer of models that have physical fabric thickness.
          finalNormal.normalize();
          finalPos = finalPos.clone().add(finalNormal.clone().multiplyScalar(0.008));
        }
        
        const dir = finalNormal.clone();
        const up = new THREE.Vector3(0, 1, 0);
        const m = new THREE.Matrix4().lookAt(new THREE.Vector3(), dir, up);
        const orientation = new THREE.Euler().setFromRotationMatrix(m);
        
        const rotZ = (el.rotation || 0) * Math.PI / 180;
        orientation.z += side === 'back' ? rotZ : -rotZ;

        const size3D = new THREE.Vector3(width3D, height3D, 0.06);
        
        geometry = new THREE.DecalGeometry(shirtMesh, finalPos, orientation, size3D);
        useDecal = true;
      } catch (err) {
        console.warn('THREE.DecalGeometry failed, falling back to PlaneGeometry:', err);
      }
    }

    if (!useDecal) {
      geometry = new THREE.PlaneGeometry(width3D, height3D);
    }

    const material = new THREE.MeshBasicMaterial({
      map: createElementTexture(el),
      transparent: true,
      alphaTest: 0.015,
      depthTest: true,
      depthWrite: false,
      polygonOffset: true,
      polygonOffsetFactor: -4,
      toneMapped: false
    });

    const decal = new THREE.Mesh(geometry, material);
    
    // Position/Rotate plane manually if using fallback
    if (!useDecal) {
      decal.position.copy(position);
      decal.rotation.z = -((el.rotation || 0) * Math.PI / 180);
      if (side === 'back') {
        decal.rotation.y = Math.PI;
      }
    }

    decal.userData = { element: el, side: side };
    decal.renderOrder = 10;
    decalGroup.add(decal);
  }

  function update3DDecals() {
    if (!is3DMode || !modelReady) return;
    disposeDecals();
    designs.front.forEach(el => addElementDecal(el, 'front'));
    designs.back.forEach(el => addElementDecal(el, 'back'));
  }

  function frame3DModel(gltfScene) {
    const box = new THREE.Box3().setFromObject(gltfScene);
    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());
    gltfScene.position.sub(center);
    modelScale = 3 / Math.max(size.y, 0.001);
    gltfScene.scale.setScalar(modelScale);
  }

  function aimCameraAtSide(side) {
    if (!camera || !controls) return;
    const z = side === 'back' ? -5.0 : 5.0;
    camera.position.set(0, 0.25, z);
    controls.target.set(0, 0, 0);
    controls.update();
  }

  function resizeRenderer() {
    if (renderer && camera && threeContainer) {
      const width = threeContainer.clientWidth || 600;
      const height = threeContainer.clientHeight || 600;
      renderer.setSize(width, height);
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
    }
  }

  let currentModelColor = '#ffffff'; // default color

  function updateMaterialColor(material, colorHex, removeBaseMap = false) {
    if (!material) return material;
    const clonedMaterial = material.clone();
    if (removeBaseMap) clonedMaterial.map = null;
    if (clonedMaterial.color) clonedMaterial.color.set(colorHex);
    if ('roughness' in clonedMaterial) clonedMaterial.roughness = 0.9;
    if ('metalness' in clonedMaterial) clonedMaterial.metalness = 0;
    clonedMaterial.needsUpdate = true;
    return clonedMaterial;
  }

  function applyColorTo3DModel(colorHex) {
    currentModelColor = colorHex;
    if (modelGroup) {
      modelGroup.traverse((child) => {
        if (child.isMesh && child.material) {
          const materials = Array.isArray(child.material) ? child.material : [child.material];
          materials.forEach((material) => {
            if (material.color) material.color.set(colorHex);
            material.needsUpdate = true;
          });
        }
      });
    }
  }

  let isDragging3D = false;
  let dragElement = null;

  function onDown3D(e) {
    if (!is3DMode || !modelReady) return;
    if (!e.isPrimary) return;
    
    // Dynamically find shirtMesh from modelGroup if it's not set
    if (!shirtMesh && modelGroup) {
      modelGroup.traverse((child) => {
        if (child.isMesh) {
          shirtMesh = child;
        }
      });
    }
    
    const rect = renderer.domElement.getBoundingClientRect();
    const mouse = new THREE.Vector2();
    mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
    
    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, camera);
    
    const intersects = raycaster.intersectObjects(decalGroup.children);
    if (intersects.length > 0) {
      const clickedDecal = intersects[0].object;
      const el = clickedDecal.userData.element;
      const side = clickedDecal.userData.side;
      
      if (el && side === currentSide && !el.locked) {
        e.preventDefault();
        e.stopPropagation();
        
        dragElement = el;
        selectedElementIndex = elements.indexOf(el);
        updateControlsState();
        
        controls.enabled = false;
        isDragging3D = true;
        if (renderer.domElement.setPointerCapture) {
          renderer.domElement.setPointerCapture(e.pointerId);
        }
        renderer.domElement.style.cursor = 'grabbing';
      }
    }
  }

  function onMove3D(e) {
    if (!is3DMode || !modelReady) return;
    
    // Dynamically find shirtMesh from modelGroup if it's not set
    if (!shirtMesh && modelGroup) {
      modelGroup.traverse((child) => {
        if (child.isMesh) {
          shirtMesh = child;
        }
      });
    }
    
    const rect = renderer.domElement.getBoundingClientRect();
    const mouse = new THREE.Vector2();
    mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
    
    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, camera);
    
    if (isDragging3D && dragElement) {
      e.preventDefault();
      e.stopPropagation();
      
      let intersected = false;
      
      if (shirtMesh) {
        modelGroup.updateMatrixWorld(true);
        shirtMesh.updateMatrixWorld(true);
        const intersects = raycaster.intersectObject(shirtMesh, true);
        if (intersects.length > 0) {
          intersected = true;
          const intersectPoint = intersects[0].point;
          
          let xNorm = intersectPoint.x / decalConfig.width;
          if (currentSide === 'back') {
            xNorm = -intersectPoint.x / decalConfig.width;
          }
          const yNorm = (decalConfig.yOffset - intersectPoint.y) / decalConfig.height;
          
          const centerX = xNorm * printBox.w + (printBox.x + printBox.w / 2);
          const centerY = yNorm * printBox.h + (printBox.y + printBox.h / 2);
          
          dragElement.x = centerX - dragElement.w / 2;
          dragElement.y = centerY - dragElement.h / 2;
          
          clampElementPosition(dragElement);
          draw();
        }
      }

      // When the pointer leaves the garment, keep the artwork at its last
      // valid surface position. Never move it onto an invisible flat plane.
      if (!intersected) return;
    } else {
      // Hover cursor effect
      if (e.pointerType === 'mouse') {
        const intersects = raycaster.intersectObjects(decalGroup.children);
        if (intersects.length > 0) {
          const clickedDecal = intersects[0].object;
          const el = clickedDecal.userData.element;
          const side = clickedDecal.userData.side;
          if (el && side === currentSide && !el.locked) {
            renderer.domElement.style.cursor = 'grab';
            return;
          }
        }
        renderer.domElement.style.cursor = 'default';
      }
    }
  }

  function onUp3D(e) {
    if (isDragging3D) {
      e.preventDefault();
      e.stopPropagation();
      isDragging3D = false;
      dragElement = null;
      controls.enabled = true;
      if (renderer.domElement.releasePointerCapture && renderer.domElement.hasPointerCapture?.(e.pointerId)) {
        renderer.domElement.releasePointerCapture(e.pointerId);
      }
      renderer.domElement.style.cursor = 'default';
      draw();
    }
  }

  function init3D() {
    if (scene) return; // already initialized
    if (!threeContainer || typeof THREE === 'undefined') return;
    
    scene = new THREE.Scene();
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(threeContainer.clientWidth, threeContainer.clientHeight);
    renderer.setClearColor(0x000000, 0);
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    renderer.physicallyCorrectLights = true;
    renderer.domElement.style.touchAction = 'none';
    threeContainer.appendChild(renderer.domElement);

    renderer.domElement.addEventListener('pointerdown', onDown3D, true);
    renderer.domElement.addEventListener('pointermove', onMove3D, true);
    window.addEventListener('pointerup', onUp3D, true);
    
    camera = new THREE.PerspectiveCamera(35, threeContainer.clientWidth / threeContainer.clientHeight, 0.1, 100);
    camera.position.set(0, 0.25, 5.0);

    controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.05;
    controls.enablePan = false;
    controls.minDistance = 1.2;
    controls.maxDistance = 12.0;

    const ambientLight = new THREE.AmbientLight(0xffffff, 1.35);
    scene.add(ambientLight);
    const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x8b8b96, 0.8);
    scene.add(hemisphereLight);
    const keyLight = new THREE.DirectionalLight(0xffffff, 1.1);
    keyLight.position.set(2, 3, 4);
    scene.add(keyLight);
    const fillLight = new THREE.DirectionalLight(0xffffff, 0.55);
    fillLight.position.set(-3, 2, -3);
    scene.add(fillLight);
    const rimLight = new THREE.DirectionalLight(0xffffff, 0.45);
    rimLight.position.set(3, 1, -4);
    scene.add(rimLight);

    modelGroup = new THREE.Group();
    decalGroup = new THREE.Group();
    scene.add(modelGroup);
    scene.add(decalGroup);

    const loaderAvailable = typeof THREE.GLTFLoader !== 'undefined';
    if (shirtModelUrl && loaderAvailable) {
      const loader = new THREE.GLTFLoader();
      loader.load(shirtModelUrl, (gltf) => {
        frame3DModel(gltf.scene);
        gltf.scene.traverse((child) => {
          if (child.isMesh && child.material) {
            // The supplied GLBs contain a baked black base-color texture.
            // Remove it so white and red variants can use their true material
            // colors instead of being multiplied back to black.
            child.material = Array.isArray(child.material)
              ? child.material.map((material) => updateMaterialColor(material, currentModelColor, true))
              : updateMaterialColor(child.material, currentModelColor, true);
            if (!shirtMesh) {
              shirtMesh = child;
            }
          }
        });
        modelGroup.add(gltf.scene);
        modelReady = true;
        aimCameraAtSide(currentSide);
        update3DDecals();
      }, undefined, (err) => {
        modelReady = false;
        threeContainer.classList.add('configurator-3d-error');
        console.warn('3D model load failed:', err);
        
        // Auto fallback to 2D mode if model load fails (e.g. 404 not uploaded yet)
        is3DMode = false;
        if (toggle3DBtn) toggle3DBtn.classList.remove('active');
        canvas.style.display = 'block';
        threeContainer.style.display = 'none';
        
        showConfigModal("Die 3D-Ansicht für dieses Produkt ist aktuell noch nicht verfügbar. Du kannst das Produkt aber ganz normal in der 2D-Ansicht gestalten!");
      });
    } else {
      threeContainer.classList.add('configurator-3d-error');
      is3DMode = false;
      if (toggle3DBtn) toggle3DBtn.classList.remove('active');
      canvas.style.display = 'block';
      threeContainer.style.display = 'none';
    }

    window.addEventListener('resize', resizeRenderer);

    function animate3D() {
      animationFrameId = requestAnimationFrame(animate3D);
      controls.update();
      renderer.render(scene, camera);
    }
    animate3D();
  }

  // Floating 3D Seiten-Overlay
  const overlay3D = document.getElementById('cfg-3d-side-overlay');
  const overlay3DFront = document.getElementById('cfg-3d-front-btn');
  const overlay3DBack  = document.getElementById('cfg-3d-back-btn');

  if (toggle3DBtn) {
    toggle3DBtn.addEventListener('click', () => {
      is3DMode = !is3DMode;
      if (is3DMode) {
        toggle3DBtn.classList.add('active');
        canvas.style.display = 'none';
        threeContainer.style.display = 'block';
        if (overlay3D) overlay3D.style.display = 'flex';
        init3D();
        aimCameraAtSide(currentSide);
        update3DDecals();
        setTimeout(resizeRenderer, 50);
      } else {
        toggle3DBtn.classList.remove('active');
        threeContainer.style.display = 'none';
        canvas.style.display = 'block';
        if (overlay3D) overlay3D.style.display = 'none';
      }
      draw();
    });
  }

  // Constrain coordinates within printable box
  function clampElementPosition(el) {
    if (el.w <= printBox.w) {
      el.x = Math.max(printBox.x, Math.min(el.x, printBox.x + printBox.w - el.w));
    } else {
      el.x = printBox.x + (printBox.w - el.w) / 2;
    }
    
    if (el.h <= printBox.h) {
      el.y = Math.max(printBox.y, Math.min(el.y, printBox.y + printBox.h - el.h));
    } else {
      el.y = printBox.y + (printBox.h - el.h) / 2;
    }
  }

  // Render loop
  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // 1. Draw background shirt base
    if (baseImage && baseImage.complete) {
      ctx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);
    }
    
    // 2. Draw printable area bounding box (2D mode only)
    if (!is3DMode) {
      ctx.save();
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
      ctx.shadowColor = 'rgba(0, 0, 0, 0.8)';
      ctx.shadowBlur = 4;
      ctx.lineWidth = 2;
      ctx.setLineDash([8, 6]);
      ctx.strokeRect(printBox.x, printBox.y, printBox.w, printBox.h);
      ctx.shadowBlur = 0; // reset
      
      ctx.fillStyle = '#ffffff';
      ctx.shadowColor = 'rgba(0, 0, 0, 0.8)';
      ctx.shadowBlur = 4;
      ctx.font = 'bold 14px sans-serif';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'bottom';
      if (isSticker) {
        ctx.fillText('Druckbereich (Gesamter Sticker)', printBox.x, printBox.y - 8);
      } else {
        ctx.fillText('Druckbereich (Max. 30x40cm)', printBox.x, printBox.y - 8);
      }
      ctx.shadowBlur = 0;
      ctx.restore();
    }
    
    // 3. Draw elements
    elements.forEach((el, index) => {
      ctx.save();
      
      const centerX = el.x + el.w / 2;
      const centerY = el.y + el.h / 2;
      
      ctx.translate(centerX, centerY);
      ctx.rotate((el.rotation || 0) * Math.PI / 180);
      
      if (el.type === 'image') {
        ctx.drawImage(el.img, -el.w / 2, -el.h / 2, el.w, el.h);
      } else if (el.type === 'text') {
        ctx.font = `bold ${el.fontSize}px "Arial Black", Impact, sans-serif`;
        ctx.fillStyle = el.color || '#000000';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(el.text, 0, 0);
      }
      
      // Draw selection box outline (2D mode only)
      if (!is3DMode && index === selectedElementIndex) {
        const themeColor = el.locked ? '#27ae60' : '#3498db'; // Changed red to a nice blue for 'move' to look less like an error
        
        ctx.strokeStyle = themeColor;
        ctx.shadowColor = 'rgba(0,0,0,0.5)';
        ctx.shadowBlur = 4;
        ctx.lineWidth = 3;
        ctx.setLineDash([6, 6]);
        ctx.strokeRect(-el.w / 2 - 6, -el.h / 2 - 6, el.w + 12, el.h + 12);
        ctx.setLineDash([]);
        ctx.shadowBlur = 0;
        
        const statusText = el.locked ? '🔒 PLATZIERT' : '✍️ BEWEGEN';
        ctx.font = 'bold 16px sans-serif';
        const textWidth = ctx.measureText(statusText).width;
        
        // Draw solid background pill for the text so it's always readable
        ctx.fillStyle = themeColor;
        ctx.shadowColor = 'rgba(0,0,0,0.3)';
        ctx.shadowBlur = 4;
        // Simple rect instead of roundRect for max compatibility
        ctx.fillRect(-textWidth / 2 - 10, -el.h / 2 - 40, textWidth + 20, 28);
        ctx.shadowBlur = 0;
        
        ctx.fillStyle = '#ffffff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(statusText, 0, -el.h / 2 - 26);
      }
      
      ctx.restore();
    });
    
    calculatePrice();
    if (is3DMode) {
      update3DDecals();
    }
    if (!isDragging && !isDragging3D) {
      updateDataInput();
    }
  }

  function hitDetection(x, y) {
    for (let i = elements.length - 1; i >= 0; i--) {
      const el = elements[i];
      if (x >= el.x && x <= el.x + el.w && y >= el.y && y <= el.y + el.h) {
        return i;
      }
    }
    return -1;
  }

  // Pointer Events
  function getPos(e) {
    const rect = canvas.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: (clientX - rect.left) * (canvas.width / rect.width),
      y: (clientY - rect.top) * (canvas.height / rect.height)
    };
  }

  function updateControlsState() {
    if (selectedElementIndex !== -1) {
      const el = elements[selectedElementIndex];
      const isLocked = !!el.locked;
      if (lockContainer) {
        lockContainer.style.display = 'flex';
        if (editToggleBtn && lockToggleBtn) {
          if (isLocked) {
            editToggleBtn.classList.remove('active');
            lockToggleBtn.classList.add('active');
          } else {
            editToggleBtn.classList.add('active');
            lockToggleBtn.classList.remove('active');
          }
        }
      }
      [zoomInBtn, zoomOutBtn, rotateLeftBtn, rotateRightBtn, removeBtn].forEach(btn => {
        if (btn) {
          if (isLocked) btn.classList.add('disabled');
          else btn.classList.remove('disabled');
        }
      });
    } else {
      if (lockContainer) lockContainer.style.display = 'none';
      if (elementControls) elementControls.classList.remove('active');
    }
  }

  function onDown(e) {
    const pos = getPos(e);
    selectedElementIndex = hitDetection(pos.x, pos.y);
    if (selectedElementIndex !== -1) {
      e.preventDefault();
      // Dragging is disabled on the flat 2D canvas per user request
      isDragging = false;
      if(elementControls) elementControls.classList.add('active');
    }
    updateControlsState();
    draw();
  }

  function onMove(e) {
    if (!isDragging || selectedElementIndex === -1) return;
    e.preventDefault();
    const pos = getPos(e);
    const el = elements[selectedElementIndex];
    if (el.locked) return;
    el.x = pos.x - startX;
    el.y = pos.y - startY;
    
    clampElementPosition(el);
    draw();
  }

  function onUp() {
    if (isDragging) {
      isDragging = false;
      draw();
    }
  }

  canvas.addEventListener('mousedown', onDown);
  canvas.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
  canvas.addEventListener('touchstart', onDown, {passive: false});
  canvas.addEventListener('touchmove', onMove, {passive: false});
  window.addEventListener('touchend', onUp);

  // Upload Image
  if(uploadBtn && fileInput) {
    uploadBtn.addEventListener('click', () => fileInput.click());
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = function(event) {
          const img = new Image();
          img.onload = function() {
            const aspectRatio = img.width / img.height;
            let w = 160;
            let h = 160 / aspectRatio;
            if (h > 240) {
              h = 240;
              w = 240 * aspectRatio;
            }
            
            const el = {
              type: 'image',
              img: img,
              originalFile: file,
              x: printBox.x + (printBox.w - w) / 2,
              y: printBox.y + (printBox.h - h) / 2,
              w: w,
              h: h,
              rotation: 0,
              locked: false
            };
            
            elements.push(el);
            selectedElementIndex = elements.length - 1;
            updateControlsState();
            draw();
          };
          img.src = event.target.result;
        };
        reader.readAsDataURL(file);
        
        // Reset file input value so uploading the same file again triggers change event
        fileInput.value = '';
      }
    });
  }

  // Add Text
  if(addTextBtn && textInput) {
    addTextBtn.addEventListener('click', () => {
      const text = textInput.value.trim();
      if (text) {
        ctx.font = 'bold 48px "Arial Black", Impact, sans-serif';
        const textMetrics = ctx.measureText(text);
        const w = textMetrics.width;
        const h = 48;
        
        const textColorInput = document.getElementById('config-text-color');
        const el = {
          type: 'text',
          text: text,
          fontSize: 48,
          color: textColorInput ? textColorInput.value : '#000000',
          x: printBox.x + (printBox.w - w) / 2,
          y: printBox.y + (printBox.h - h) / 2,
          w: w,
          h: h,
          rotation: 0,
          locked: false
        };
        
        elements.push(el);
        selectedElementIndex = elements.length - 1;
        updateControlsState();
        textInput.value = '';
        draw();
      }
    });
  }

  // Controls
  if(zoomInBtn) {
    zoomInBtn.addEventListener('click', () => {
      if (selectedElementIndex !== -1) {
        const el = elements[selectedElementIndex];
        if (el.locked) return;
        
        // Prevent scaling past printable area dimensions
        if (el.w * 1.1 > printBox.w || el.h * 1.1 > printBox.h) {
          showConfigModal('Maximale Druckgröße erreicht!');
          return;
        }
        
        el.w *= 1.1;
        el.h *= 1.1;
        if (el.type === 'text') {
           el.fontSize *= 1.1;
           ctx.font = `bold ${el.fontSize}px "Arial Black", Impact, sans-serif`;
           el.w = ctx.measureText(el.text).width;
        }
        clampElementPosition(el);
        draw();
      }
    });
  }

  if(zoomOutBtn) {
    zoomOutBtn.addEventListener('click', () => {
      if (selectedElementIndex !== -1) {
        const el = elements[selectedElementIndex];
        if (el.locked) return;
        if (el.w * 0.9 < 30 || el.h * 0.9 < 30) return; // min size constraint
        
        el.w *= 0.9;
        el.h *= 0.9;
        if (el.type === 'text') {
           el.fontSize *= 0.9;
           ctx.font = `bold ${el.fontSize}px "Arial Black", Impact, sans-serif`;
           el.w = ctx.measureText(el.text).width;
        }
        clampElementPosition(el);
        draw();
      }
    });
  }

  if(rotateLeftBtn) {
    rotateLeftBtn.addEventListener('click', () => {
      if (selectedElementIndex !== -1) {
        const el = elements[selectedElementIndex];
        if (el.locked) return;
        el.rotation = (el.rotation || 0) - 15;
        draw();
      }
    });
  }

  if(rotateRightBtn) {
    rotateRightBtn.addEventListener('click', () => {
      if (selectedElementIndex !== -1) {
        const el = elements[selectedElementIndex];
        if (el.locked) return;
        el.rotation = (el.rotation || 0) + 15;
        draw();
      }
    });
  }

  if(removeBtn) {
    removeBtn.addEventListener('click', () => {
      if (selectedElementIndex !== -1) {
        const el = elements[selectedElementIndex];
        if (el.locked) return;
        elements.splice(selectedElementIndex, 1);
        selectedElementIndex = -1;
        updateControlsState();
        draw();
      }
    });
  }

  // Fullscreen with body-move layout z-index fix
  let originalParent = null;
  let originalSibling = null;

  function toggleFullscreen() {
    const isCurrentlyFullscreen = wrapper.classList.contains('is-fullscreen');
    if (!isCurrentlyFullscreen) {
      fullscreenBtn.innerText = '❌ Ansicht verkleinern';
      if (doneBtn) doneBtn.style.display = 'block';
      
      originalParent = wrapper.parentNode;
      originalSibling = wrapper.nextSibling;
      
      document.body.appendChild(wrapper);
      document.body.classList.add('configurator-open');
      wrapper.classList.add('is-fullscreen');
    } else {
      fullscreenBtn.innerText = '🔍 Großansicht öffnen';
      if (doneBtn) doneBtn.style.display = 'none';
      
      if (originalParent) {
        originalParent.insertBefore(wrapper, originalSibling);
      }
      document.body.classList.remove('configurator-open');
      wrapper.classList.remove('is-fullscreen');
    }
    setTimeout(() => {
      draw();
      resizeRenderer();
    }, 50);
  }

  if (fullscreenBtn) {
    fullscreenBtn.addEventListener('click', toggleFullscreen);
  }
  if (doneBtn) {
    doneBtn.addEventListener('click', toggleFullscreen);
  }

  // Side Toggle Logic
  function switchSide(side) {
    if (currentSide === side) return;
    selectedElementIndex = -1;
    currentSide = side;
    elements = designs[side];
    
    if (side === 'front') {
      if (frontBtn) frontBtn.classList.add('active');
      if (backBtn)  backBtn.classList.remove('active');
      if (overlay3DFront) overlay3DFront.classList.add('active');
      if (overlay3DBack)  overlay3DBack.classList.remove('active');
      baseImage.src = frontImageUrl || baseImage.src;
    } else {
      if (backBtn)  backBtn.classList.add('active');
      if (frontBtn) frontBtn.classList.remove('active');
      if (overlay3DBack)  overlay3DBack.classList.add('active');
      if (overlay3DFront) overlay3DFront.classList.remove('active');
      baseImage.src = backImageUrl || baseImage.src;
    }
    aimCameraAtSide(side);
    draw();
  }

  if (frontBtn) frontBtn.addEventListener('click', () => switchSide('front'));
  if (backBtn)  backBtn.addEventListener('click',  () => switchSide('back'));
  // Floating Overlay-Buttons
  if (overlay3DFront) overlay3DFront.addEventListener('click', () => switchSide('front'));
  if (overlay3DBack)  overlay3DBack.addEventListener('click',  () => switchSide('back'));

  // Close fullscreen when clicking outside
  document.addEventListener('click', (e) => {
    if (wrapper && wrapper.classList.contains('is-fullscreen')) {
      if (!configuratorContainer.contains(e.target) && 
          e.target !== fullscreenBtn && 
          !e.target.closest('.configurator-controls-overlay') &&
          e.target.id !== 'config-remove') {
        toggleFullscreen();
      }
    }
  });

  // Price Calculation according to store requirements
  function calculatePrice() {
    const handle = configuratorContainer ? configuratorContainer.getAttribute('data-product-handle') || '' : '';
    const hasFrontDesign = designs.front.length > 0;
    const hasBackDesign  = designs.back.length  > 0;
    const bothSides      = hasFrontDesign && hasBackDesign;
    const isWindbreaker  = handle.includes('windbreaker');
    const isHoodie       = handle.includes('hoodie');
    const isShirt        = handle.includes('t-shirt') || handle.includes('shirt');
    let price = basePrice; // Nur Vorderseite = Shopify Basispreis
    if (bothSides) {
      if (isWindbreaker || isHoodie) { price = 50.00; }
      else if (isShirt)              { price = 24.90; }
    }
    const priceDisplay = document.getElementById('config-live-price');
    if (priceDisplay) { priceDisplay.innerText = price.toFixed(2).replace('.', ',') + ' \u20ac'; }
    if (priceDisplay) { priceDisplay.innerText = price.toFixed(2).replace('.', ',') + ' \u20ac'; }
  }

  // Helper to export transparent PNG containing only the customer's design elements (optimized size)
  function exportDesignPNG(side, size = 400) {
    const tempCanvas = document.createElement('canvas');
    tempCanvas.height = size;
    const tempCtx = tempCanvas.getContext('2d');
    
    const scale = size / canvas.width;
    const sideElements = designs[side];
    sideElements.forEach(el => {
      tempCtx.save();
      const centerX = (el.x + el.w / 2) * scale;
      const centerY = (el.y + el.h / 2) * scale;
      tempCtx.translate(centerX, centerY);
      tempCtx.rotate((el.rotation || 0) * Math.PI / 180);
      
      const w = el.w * scale;
      const h = el.h * scale;
      
      if (el.type === 'image' && el.img) {
        tempCtx.drawImage(el.img, -w / 2, -h / 2, w, h);
      } else if (el.type === 'text') {
        const fontSize = el.fontSize * scale;
        tempCtx.font = `bold ${fontSize}px "Arial Black", Impact, sans-serif`;
        tempCtx.fillStyle = el.color || '#000000';
        tempCtx.textAlign = 'center';
        tempCtx.textBaseline = 'middle';
        tempCtx.fillText(el.text, 0, 0);
      }
      tempCtx.restore();
    });
    
    return tempCanvas.toDataURL('image/png');
  }

  // Helper to export a visual proof image with the product mockup and placed design elements.
  function exportPreviewPNG(side, size = 800) {
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = size;
    tempCanvas.height = size;
    const tempCtx = tempCanvas.getContext('2d');
    const sideElements = designs[side];
    const scale = size / canvas.width;
    const previewImage = previewImages[side] || previewImages.front;

    tempCtx.fillStyle = '#ffffff';
    tempCtx.fillRect(0, 0, size, size);

    if (previewImage && previewImage.complete && previewImage.naturalWidth > 0) {
      tempCtx.drawImage(previewImage, 0, 0, size, size);
    }

    sideElements.forEach(el => {
      tempCtx.save();
      const centerX = (el.x + el.w / 2) * scale;
      const centerY = (el.y + el.h / 2) * scale;
      tempCtx.translate(centerX, centerY);
      tempCtx.rotate((el.rotation || 0) * Math.PI / 180);

      const w = el.w * scale;
      const h = el.h * scale;

      if (el.type === 'image' && el.img) {
        tempCtx.drawImage(el.img, -w / 2, -h / 2, w, h);
      } else if (el.type === 'text') {
        const fontSize = el.fontSize * scale;
        tempCtx.font = `bold ${fontSize}px "Arial Black", Impact, sans-serif`;
        tempCtx.fillStyle = el.color || '#000000';
        tempCtx.textAlign = 'center';
        tempCtx.textBaseline = 'middle';
        tempCtx.fillText(el.text, 0, 0);
      }

      tempCtx.restore();
    });

    return tempCanvas.toDataURL('image/png');
  }

  // Helper to convert base64 to File object
  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[arr.length - 1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  // Set file input programmatically
  function setFileInput(inputEl, dataurl, filename) {
    if (!dataurl) {
      inputEl.value = '';
      return;
    }
    try {
      const file = dataURLtoFile(dataurl, filename);
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      inputEl.files = dataTransfer.files;
    } catch (e) {
      console.warn("Failed to set file input:", e);
    }
  }

  // Output Data
  function updateDataInput() {
    if (frontInput) {
      if (designs.front.length === 0) frontInput.value = 'Kein Design';
      else frontInput.value = designs.front.map((el, i) => {
        let pctX = ((el.x / canvas.width) * 100).toFixed(1);
        let pctY = ((el.y / canvas.height) * 100).toFixed(1);
        let pctW = ((el.w / canvas.width) * 100).toFixed(1);
        return el.type === 'image' 
          ? `Bild ${i+1} (Pos: X ${pctX}%, Y ${pctY}% | Größe: ${pctW}% | Rot: ${el.rotation || 0}°)`
          : `Text "${el.text}" (Pos: X ${pctX}%, Y ${pctY}% | Größe: ${pctW}% | Rot: ${el.rotation || 0}°)`;
      }).join(', ');
    }
    if (backInput) {
      if (designs.back.length === 0) backInput.value = 'Kein Design';
      else backInput.value = designs.back.map((el, i) => {
        let pctX = ((el.x / canvas.width) * 100).toFixed(1);
        let pctY = ((el.y / canvas.height) * 100).toFixed(1);
        let pctW = ((el.w / canvas.width) * 100).toFixed(1);
        return el.type === 'image' 
          ? `Bild ${i+1} (Pos: X ${pctX}%, Y ${pctY}% | Größe: ${pctW}% | Rot: ${el.rotation || 0}°)`
          : `Text "${el.text}" (Pos: X ${pctX}%, Y ${pctY}% | Größe: ${pctW}% | Rot: ${el.rotation || 0}°)`;
      }).join(', ');
    }
    
    // Set transparent design print files for the order properties
    if (printFrontInput) {
      const dataUrl = designs.front.length > 0 ? exportDesignPNG('front') : '';
      setFileInput(printFrontInput, dataUrl, 'druckdatei_vorderseite.png');
    }
    if (printBackInput) {
      const dataUrl = designs.back.length > 0 ? exportDesignPNG('back') : '';
      setFileInput(printBackInput, dataUrl, 'druckdatei_rueckseite.png');
    }
    if (previewFrontInput) {
      const dataUrl = designs.front.length > 0 ? exportPreviewPNG('front') : '';
      setFileInput(previewFrontInput, dataUrl, 'vorschau_vorderseite.png');
    }
    if (previewBackInput) {
      const dataUrl = designs.back.length > 0 ? exportPreviewPNG('back') : '';
      setFileInput(previewBackInput, dataUrl, 'vorschau_rueckseite.png');
    }
    
    // Attach customer's original uploaded files (full resolution, unmodified)
    if (originalFrontInput) {
      const frontImages = designs.front.filter(el => el.type === 'image' && el.originalFile);
      if (frontImages.length > 0) {
        const dt = new DataTransfer();
        frontImages.forEach((el, i) => {
          const ext = el.originalFile.name.split('.').pop();
          const renamed = new File([el.originalFile], `original_vorderseite_${i + 1}.${ext}`, { type: el.originalFile.type });
          dt.items.add(renamed);
        });
        originalFrontInput.files = dt.files;
      } else {
        originalFrontInput.value = '';
      }
    }
    if (originalBackInput) {
      const backImages = designs.back.filter(el => el.type === 'image' && el.originalFile);
      if (backImages.length > 0) {
        const dt = new DataTransfer();
        backImages.forEach((el, i) => {
          const ext = el.originalFile.name.split('.').pop();
          const renamed = new File([el.originalFile], `original_rueckseite_${i + 1}.${ext}`, { type: el.originalFile.type });
          dt.items.add(renamed);
        });
        originalBackInput.files = dt.files;
      } else {
        originalBackInput.value = '';
      }
    }
  }

  // Helper to sync variant details (price, 3D model color, base image) on load and variant change
  function syncVariantDetails() {
    const urlParams = new URLSearchParams(window.location.search);
    const selectedVariantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    const variantId = selectedVariantInput?.value || urlParams.get('variant');
    const handle = configuratorContainer ? configuratorContainer.getAttribute('data-product-handle') : null;
    if (handle) {
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
          let targetVariant = product.variants[0];
          if (variantId) {
            targetVariant = product.variants.find(v => v.id.toString() === variantId) || targetVariant;
          }
          if (targetVariant) {
            // Sync price
            basePrice = targetVariant.price / 100;
            if (configuratorContainer) {
              configuratorContainer.setAttribute('data-base-price', basePrice.toString());
            }
            
            // Detect variant color and apply to 3D model
            const colorOptionIndex = (product.options || []).findIndex((option) => {
              const optionName = typeof option === 'string' ? option : option.name;
              return ['farbe', 'color', 'colour'].includes((optionName || '').toLowerCase());
            });
            const variantColor = colorOptionIndex >= 0
              ? (targetVariant.options?.[colorOptionIndex] || '')
              : (targetVariant.title || '');
            const normalizedColor = variantColor.toLowerCase();
            let matchedColor = '#ffffff';
            
            if (normalizedColor.includes('schwarz') || normalizedColor.includes('black')) {
              matchedColor = '#202020'; // Black shirt reference
            } else if (normalizedColor.includes('rot') || normalizedColor.includes('red')) {
              matchedColor = '#ed2612'; // Fire-red shirt reference
            } else if (normalizedColor.includes('weiß') || normalizedColor.includes('weiss') || normalizedColor.includes('white')) {
              matchedColor = handle === 'premium-windbreaker-blanko-hoodplaka67'
                ? '#deded8' // Subtle omagrau for the white windbreaker
                : '#f4f4f4'; // White shirt reference
            } else if (normalizedColor.includes('grau') || normalizedColor.includes('grey') || normalizedColor.includes('gray')) {
              matchedColor = '#a8a8a8'; // Heather gray
            } else if (normalizedColor.includes('blau') || normalizedColor.includes('blue') || normalizedColor.includes('navy') || normalizedColor.includes('marine')) {
              matchedColor = '#1d2a44'; // Navy blue
            } else if (normalizedColor.includes('grün') || normalizedColor.includes('green') || normalizedColor.includes('oliv')) {
              matchedColor = '#2e4428'; // Olive green
            } else if (normalizedColor.includes('gelb') || normalizedColor.includes('yellow')) {
              matchedColor = '#f2c94c'; // Yellow
            }
            
            applyColorTo3DModel(matchedColor);
            
            // Dynamically show/hide the back side toggle based on selected variant options
            let hasPrintOption = false;
            if (product.variants) {
              product.variants.forEach(v => {
                const t = (v.title || '').toLowerCase();
                if (t.includes('vorderseite') || t.includes('rückseite') || t.includes('beidseitig')) {
                  hasPrintOption = true;
                }
              });
            }

            let backSideAllowed = true;
            if (hasPrintOption) {
              const variantTitleLower = (targetVariant.title || '').toLowerCase();
              backSideAllowed = variantTitleLower.includes('rückseite') || 
                                variantTitleLower.includes('beidseitig') || 
                                variantTitleLower.includes('back') || 
                                variantTitleLower.includes('both');
            }

            if (backBtn) {
              if (backSideAllowed) {
                backBtn.style.display = 'inline-block';
              } else {
                backBtn.style.display = 'none';
                
                // Clear all elements on the back side since it is no longer allowed!
                if (designs.back.length > 0) {
                  designs.back = [];
                  updateDataInput();
                }
                
                // Switch back to front if currently on back
                if (currentSide === 'back') {
                  currentSide = 'front';
                  elements = designs.front;
                  if (frontBtn) frontBtn.classList.add('active');
                  if (backBtn) backBtn.classList.remove('active');
                  if (is3DMode) {
                    aimCameraAtSide('front');
                    update3DDecals();
                  } else {
                    draw();
                  }
                } else {
                  if (is3DMode) {
                    update3DDecals();
                  } else {
                    draw();
                  }
                }
              }
            }
            
            // Keep Shopify gallery and 2D product imagery unchanged. Only the
            // 3D material color follows the selected variant.
            if (targetVariant.featured_image) {
              baseImage.src = targetVariant.featured_image.src || targetVariant.featured_image;
              baseImage.onload = draw;
            } else {
              draw();
            }
          }
        })
        .catch(err => console.error('Error syncing variant details:', err));
    }
  }

  // Bind click listeners on segmented lock buttons
  if (editToggleBtn) {
    editToggleBtn.addEventListener('click', () => {
      if (selectedElementIndex !== -1) {
        elements[selectedElementIndex].locked = false;
        updateControlsState();
        draw();
      }
    });
  }
  if (lockToggleBtn) {
    lockToggleBtn.addEventListener('click', () => {
      if (selectedElementIndex !== -1) {
        elements[selectedElementIndex].locked = true;
        updateControlsState();
        draw();
      }
    });
  }

  // Initial draw & sync
  if (baseImage) {
    if (baseImage.complete) {
      draw();
    } else {
      baseImage.addEventListener('load', draw);
    }
  }
  syncVariantDetails();

  // Variant Syncing
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects') || e.target.closest('variant-radios') || e.target.name === 'id') {
      setTimeout(syncVariantDetails, 100);
    }
  });

  // ── imgbb Upload: Bilder hochladen & URL in Bestellung speichern ──────────
  const IMGBB_KEY = '266ef4f43d0bb40293fffa8b0bfe32ed';

  async function uploadToImgbb(base64DataUrl, filename) {
    // Strip the data:image/...;base64, prefix
    const base64 = base64DataUrl.split(',')[1];
    const formData = new FormData();
    formData.append('key', IMGBB_KEY);
    formData.append('image', base64);
    formData.append('name', filename);

    const res = await fetch('https://api.imgbb.com/1/upload', {
      method: 'POST',
      body: formData
    });
    const json = await res.json();
    if (json.success) {
      return json.data.url; // permanent direct image URL
    }
    throw new Error('imgbb upload failed: ' + (json.error?.message || 'unknown'));
  }

  // Intercept the Shopify add-to-cart form submit
  const productForm = document.getElementById(
    configuratorContainer
      ? 'product-form-' + (document.querySelector('[data-section-id]')?.dataset?.sectionId ||
          document.querySelector('product-form')?.closest('[id]')?.id?.replace('product-form-','') || '')
      : null
  ) || document.querySelector('form[action*="/cart/add"]');

  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      // Only intercept if there are any designs
      const hasFront = designs.front.length > 0;
      const hasBack  = designs.back.length  > 0;
      if (!hasFront && !hasBack) return; // nothing to upload, proceed normally

      e.preventDefault();
      e.stopImmediatePropagation();

      // Show loading state on the submit button
      const submitBtn = productForm.querySelector('[type="submit"]');
      const origBtnText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '⏳ Motiv wird hochgeladen...';
      }

      try {
        // Upload front design images
        if (hasFront) {
          const frontImages = designs.front.filter(el => el.type === 'image' && el.originalFile);
          const frontUrls = [];

          for (let i = 0; i < frontImages.length; i++) {
            const el = frontImages[i];
            // Upload original file
            const reader = new FileReader();
            const origDataUrl = await new Promise((resolve, reject) => {
              reader.onload = e => resolve(e.target.result);
              reader.onerror = reject;
              reader.readAsDataURL(el.originalFile);
            });
            const origUrl = await uploadToImgbb(origDataUrl, `original_vorderseite_${i+1}`);
            frontUrls.push(origUrl);
          }

          // Upload the composed print file (transparent PNG)
          const printDataUrl = exportDesignPNG('front');
          const printUrl = await uploadToImgbb(printDataUrl, 'druckdatei_vorderseite');

          // Upload the preview mockup
          const previewDataUrl = exportPreviewPNG('front');
          const previewUrl = await uploadToImgbb(previewDataUrl, 'vorschau_vorderseite');

          // Write URLs as text into order properties
          if (frontInput) {
            // Keep position info + add download links
            const posInfo = designs.front.map((el, i) => {
              const pctX = ((el.x / canvas.width) * 100).toFixed(1);
              const pctY = ((el.y / canvas.height) * 100).toFixed(1);
              const pctW = ((el.w / canvas.width) * 100).toFixed(1);
              return el.type === 'image'
                ? `Bild ${i+1} (X ${pctX}%, Y ${pctY}%, Gr: ${pctW}%, Rot: ${el.rotation||0}°)`
                : `Text "${el.text}" (X ${pctX}%, Y ${pctY}%, Gr: ${pctW}%, Rot: ${el.rotation||0}°)`;
            }).join(' | ');
            frontInput.value = posInfo;
          }

          // Inject URL inputs dynamically (as hidden text fields)
          setOrCreateHiddenInput(productForm, 'Druckdatei Vorderseite', printUrl);
          setOrCreateHiddenInput(productForm, 'Vorschau Vorderseite', previewUrl);
          frontUrls.forEach((url, i) => {
            setOrCreateHiddenInput(productForm, `Originaldatei Vorderseite ${i+1}`, url);
          });
        }

        // Upload back design images
        if (hasBack) {
          const backImages = designs.back.filter(el => el.type === 'image' && el.originalFile);
          const backUrls = [];

          for (let i = 0; i < backImages.length; i++) {
            const el = backImages[i];
            const reader = new FileReader();
            const origDataUrl = await new Promise((resolve, reject) => {
              reader.onload = e => resolve(e.target.result);
              reader.onerror = reject;
              reader.readAsDataURL(el.originalFile);
            });
            const origUrl = await uploadToImgbb(origDataUrl, `original_rueckseite_${i+1}`);
            backUrls.push(origUrl);
          }

          const printDataUrl = exportDesignPNG('back');
          const printUrl = await uploadToImgbb(printDataUrl, 'druckdatei_rueckseite');

          const previewDataUrl = exportPreviewPNG('back');
          const previewUrl = await uploadToImgbb(previewDataUrl, 'vorschau_rueckseite');

          if (backInput) {
            const posInfo = designs.back.map((el, i) => {
              const pctX = ((el.x / canvas.width) * 100).toFixed(1);
              const pctY = ((el.y / canvas.height) * 100).toFixed(1);
              const pctW = ((el.w / canvas.width) * 100).toFixed(1);
              return el.type === 'image'
                ? `Bild ${i+1} (X ${pctX}%, Y ${pctY}%, Gr: ${pctW}%, Rot: ${el.rotation||0}°)`
                : `Text "${el.text}" (X ${pctX}%, Y ${pctY}%, Gr: ${pctW}%, Rot: ${el.rotation||0}°)`;
            }).join(' | ');
            backInput.value = posInfo;
          }

          setOrCreateHiddenInput(productForm, 'Druckdatei Rückseite', printUrl);
          setOrCreateHiddenInput(productForm, 'Vorschau Rückseite', previewUrl);
          backUrls.forEach((url, i) => {
            setOrCreateHiddenInput(productForm, `Originaldatei Rückseite ${i+1}`, url);
          });
        }

        // Remove the old file inputs so they don't break the submit
        [printFrontInput, printBackInput, previewFrontInput, previewBackInput,
          originalFrontInput, originalBackInput].forEach(el => {
          if (el) el.remove();
        });

        // Now submit the form normally
        productForm.submit();

      } catch (err) {
        console.error('Upload error:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = origBtnText;
        }
        showConfigModal('Bild-Upload fehlgeschlagen. Bitte prüfe deine Internetverbindung und versuche es erneut.');
      }
    }, true); // useCapture: true → fires before Shopify's own listener
  }

  // Helper: find or create a hidden text input for an order property
  function setOrCreateHiddenInput(form, propertyName, value) {
    const name = `properties[${propertyName}]`;
    let el = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

});

